<template>
	<div class="groupList">
		<sideBar></sideBar>
		<div class=" main">
			<div class="pull-left">
				<div class="search-input">
					<div class="search-icon"></div>
					<input type="text" :value="q" v-on:input="search($event)" class="noneInput" placeholder="输入搜索内容" style="">
				</div>
			</div>
			<div class="pull-right">
				<a class="add-btn" href="/groupEdit">
					<div class="add-icon add-icon2"></div>
					新增
				</a>
			</div>
				<table class="" border="0" cellspacing="0" cellpadding="0">
					<colgroup width="5%"></colgroup>
					<colgroup width="38.8%"></colgroup>
					<colgroup width="11.153%"></colgroup>
					<colgroup width="32.3%"></colgroup>
					<colgroup></colgroup>
					<tr>
						<th>编号</th>
						<th>分组名称</th>
						<th>人数</th>
						<th>创建时间</th>
						<th>操作</th>
					</tr>
					<tr v-for="item in listFunData" v-if="listFunData.length>0">
						<td class="first-col id">{{item.id}}</td>
						<td :title="item.nickname">{{item.groupname}}</td>
						<td :title="item.groupname">{{item.count}}</td>
						<td><span :title="moment(item.createat).format('YYYY-MM-DD HH:mm:ss')"> {{moment(item.createat).fromNow()}}</span></td>
						<td class="last-col">
							<div class="btn-group" v-if = "item.canEdit==1">
								<a class="deal-btn edit-btn" :href="'/groupEdit?id='+item.id"></a>
								<a class="deal-btn li-last del-btn" href="javascript:void(0)" @click="deleteItem($event)"></a>
							</div>
						</td>
					</tr>
					<tr v-if="listFunData.length<=0">
						<td :colspan="5" class="nodata">
							暂无数据...
						</td>
					</tr>
				</table>
				<div class = "list-processing" v-if = "listStatus">处理中...</div>
			<pagination :total="count" :current-page='dataTable.currentPage' :totalPage='totalPage' @pagechange="pagechange"></pagination>
		</div>
	</div>
</template>

<script>
	import pagination from "@/components/pagination"
	import sideBar from "@/components/comHtml/sideBar"
	export default {
		name: 'groupList',
		data() {
			return {
				listFunData: [],
				click: false,
				totalPage: 1,
				count: 1,
				q: "",
				listStatus:false,
				dataTable: {
					//总页数
					currentPage: 1,
					start: 0,
					pageSize: 12 //每页数据量
				}
			}
		},
		components: {
			sideBar,
			pagination
		},
		created: function() {
			this.init();
		},
		mounted: function() {
			let _this = this;
		},
		methods: {
			init: function() {
				if(localStorage.getItem("dataTable" + this.$route.name) != null) {
					this.dataTable = JSON.parse(localStorage.getItem("dataTable" + this.$route.name))
				}
				this.refreshTable();
			},
			pagechange: function(currentPage) {
				this.click = true;
				this.dataTable.currentPage = currentPage;
				this.dataTable.start = this.dataTable.pageSize * (currentPage - 1);
				this.refreshTable();
			},
			listFun: function(data) {
				if(data && data.errcode == '0') {
					this.listStatus = false;
					this.totalPage = Math.ceil(data.count / this.dataTable.pageSize);
					this.count = data.count;
					if(this.click == true) {
						localStorage.setItem("dataTable" + this.$route.name, JSON.stringify(this.dataTable));
					}
					this.listFunData = data.list;
				}
			},
			search: function($event) {
				this.q = $.trim($event.target.value);
				this.click = false;
				this.start = 0;
				this.dataTable.currentPage = 1;
				this.refreshTable();
			},
			deleteItem: function($event) {
				let _this = this
				let id = $($event.currentTarget).parents("tr").find('.id').text();
				let item = $($event.currentTarget).parents("tr");
				this.layer.confirm("确定删除吗?", (index) => {
					this.layer.close(index);
					this.common.get("group/deleteGroup", function(ret) {
						if(ret.errcode) {
							return _this.layer.alert(ret.errmsg);
						}
						_this.layer.alert(ret.errmsg);
						_this.refreshTable();
					},{id: id},true)
				})
			},
			//			lock:function(data){
			//				this.refreshTable()
			//			},
			refreshTable: function(data) {
				data = {
					start: this.dataTable.start,
					limit: this.dataTable.pageSize,
					q: this.q
				}
				this.common.get('group/groupList', this.listFun, data,true,()=>{
						this.listStatus = true
					});
			}
		}

	}
</script>

<style scoped="">
	@import url("../../static/css/table.css");
</style>


// WEBPACK FOOTER //
// src/assets/groupList.vue